import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { StepsDataService, StepsColumnsService } from '../../../services';
import { Step, StepsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-step-details',
  templateUrl: './step-details.component.html',
  styleUrls: ['./step-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class StepDetailsComponent implements OnInit, OnDestroy {

  public step: Step = {};
  public steps: Step[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'fr';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private stepsDataService: StepsDataService,
    private stepsColumnsService: StepsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Step - Details');
        this.getStep(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.step !== 'undefined') {
      this.step = this.dynamicDialogConfig.data.step;
    }
    this.columns = this.stepsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getStep(id: number): void {
    this.isLoading = true;
    this.stepsDataService.getStep(id).subscribe((response: Step|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.step = response;
      }
    });
  }

  list() {
    this.router.navigate(['/steps']);
  }

  add() {
    this.router.navigate(['/steps/add']);
  }

  edit() {
    this.router.navigate(['/steps/edit/' + this.step.id]);
  }

}
@Component({
  selector: 'app-step-details',
  templateUrl: './step-details.component.html',
  styleUrls: ['./step-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogStepDetailsComponent extends StepDetailsComponent {
}

